// extracted by mini-css-extract-plugin
export var changeIcon = "_3v-4";
export var container = "_3v-0";
export var divider = "_3v-7";
export var externalLinkIcon = "_3v-1";
export var green = "_3v-5";
export var helpCircleIcon = "_3v-3";
export var iconButton = "_3v-2";
export var red = "_3v-6";